import { render } from "./shop-sidebar-web-category.vue?vue&type=template&id=a5527bae&scoped=true"
import script from "./shop-sidebar-web-category.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-web-category.vue?vue&type=script&lang=js"

import "./shop-sidebar-web-category.vue?vue&type=style&index=0&id=a5527bae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5527bae"]])

export default __exports__